import { inject, Pipe, PipeTransform } from '@angular/core';
import { PhoneService } from '@services/shared/phone.service';

/**
 * Phone formatting pipe.
 * Default mode prints the full phone (`+34 612 345 678`). Use mode='local'
 * to hide the +34 prefix when the number is Spanish — non-Spanish prefixes
 * are kept so foreign numbers are still unambiguous.
 */
@Pipe({
	name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
	private phoneService = inject(PhoneService);

	transform(value: string | null | undefined, mode: 'full' | 'local' = 'full'): string {
		return mode === 'local'
			? this.phoneService.formatForDisplayLocal(value)
			: this.phoneService.formatForDisplay(value);
	}
}
